export default {
    title: 'Statistik',

    serial_number: 'LfdNr.',
    name: 'Name',
    organisation: 'Organisation',
    statisticSurvey: 'Erhebung',
    statisticSurveyPeriod: 'Erhebungszeitraum',
    statisticForm: 'Statistikformular',
    processes: 'Vorgänge',
    status: 'Status',
    statusKey: 'Status',
    association: 'Verband',
}